module.exports = {"Born1":{"daobanList":[{"title":"1:是否办理国（境）内出生登记(随父（或母）入户登记)","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、申办报告（广州）","state":"必要"},{"name":"2、居名户口薄","state":"必要"},{"name":"3、居民身份证","state":"必要"},{"name":"4、结婚证（或婚姻状况材料）","state":"必要"},{"name":"5、出生医学证明","state":"必要"},{"name":"6、入户同意书","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdb-1.json
// module id = 1232
// module chunks = 0